const currentAccountData = [
  {
    accountNumber: 4534534534535,
    name: "Nguyen Xuan A",
    branch: "CN Sai Gon",
    currency: "VND",
    available: "600.000.000",
  },
  {
    accountNumber: 4534534534536,
    name: "Le Thi B",
    branch: "Chi nhanh Ha Noi",
    currency: "VND",
    available: "1.200.000",
  },
  {
    accountNumber: 4534534534537,
    name: "Tran Minh C",
    branch: "Chi nhanh Da Nang",
    currency: "VND",
    available: "800.000",
  },
  {
    accountNumber: 4534534534538,
    name: "Pham Thi D",
    branch: "Chi nhanh Hai Phong",
    currency: "VND",
    available: "1.500.000",
  },
  {
    accountNumber: 4534534534539,
    name: "Hoang Duc E",
    branch: "Chi nhanh Can Tho",
    currency: "VND",
    available: "2.000.000",
  },
  {
    accountNumber: 4534534534540,
    name: "Nguyen Thi F",
    branch: "Chi nhanh Vinh",
    currency: "VND",
    available: "400.000",
  },
  {
    accountNumber: 4534534534541,
    name: "Nguyen Minh G",
    branch: "Chi nhanh Nha Trang",
    currency: "VND",
    available: "350.000",
  },
  {
    accountNumber: 4534534534542,
    name: "Pham Minh H",
    branch: "Chi nhanh Quang Ninh",
    currency: "VND",
    available: "900.000",
  },
  {
    accountNumber: 4534534534543,
    name: "Tran Thi I",
    branch: "Chi nhanh Bac Ninh",
    currency: "VND",
    available: "3.000.000",
  },
  {
    accountNumber: 4534534534544,
    name: "Hoang Thi J",
    branch: "Chi nhanh Hai Duong",
    currency: "VND",
    available: "1.500.000",
  },
];

const depositAccountData = [
  {
    accountNumber: 32432324324,
    availableBalance: "431.209.000",
    currency: "VND",
    maturityDate: "22/12/2023",
    status: true,
  },
  {
    accountNumber: 32432324325,
    availableBalance: "500.000.000",
    currency: "VND",
    maturityDate: "15/01/2024",
    status: false,
  },
  {
    accountNumber: 32432324326,
    availableBalance: "350.000.000",
    currency: "VND",
    maturityDate: "10/02/2024",
    status: false,
  },
  {
    accountNumber: 32432324327,
    availableBalance: "800.000.000",
    currency: "VND",
    maturityDate: "05/03/2024",
    status: true,
  },
  {
    accountNumber: 32432324328,
    availableBalance: "1.000.000.000",
    currency: "VND",
    maturityDate: "22/04/2024",
    status: true,
  },
  {
    accountNumber: 32432324329,
    availableBalance: "650.000.000",
    currency: "VND",
    maturityDate: "01/06/2024",
    status: true,
  },
  {
    accountNumber: 32432324330,
    availableBalance: "900.000.000",
    currency: "VND",
    maturityDate: "17/07/2024",
    status: true,
  },
  {
    accountNumber: 32432324331,
    availableBalance: "420.000.000",
    currency: "VND",
    maturityDate: "30/08/2024",
    status: true,
  },
];

const loanAccountData = [
  {
    accountNumber: "LD100632",
    outstandingBalance: "431.209.000",
    currency: "VND",
    maturityDate: "22/12/2023",
    status: true,
  },
  {
    accountNumber: "LD100633",
    outstandingBalance: "550.000.000",
    currency: "VND",
    maturityDate: "15/01/2024",
    status: false,
  },
  {
    accountNumber: "LD100634",
    outstandingBalance: "700.000.000",
    currency: "VND",
    maturityDate: "28/02/2024",
    status: true,
  },
  {
    accountNumber: "LD100635",
    outstandingBalance: "1.200.000.000",
    currency: "VND",
    maturityDate: "10/03/2024",
    status: false,
  },
  {
    accountNumber: "LD100636",
    outstandingBalance: "900.000.000",
    currency: "VND",
    maturityDate: "01/04/2024",
    status: true,
  },
  {
    accountNumber: "LD100637",
    outstandingBalance: "450.000.000",
    currency: "VND",
    maturityDate: "25/05/2024",
    status: false,
  },
  {
    accountNumber: "LD100638",
    outstandingBalance: "600.000.000",
    currency: "VND",
    maturityDate: "15/06/2024",
    status: true,
  },
  {
    accountNumber: "LD100639",
    outstandingBalance: "300.000.000",
    currency: "VND",
    maturityDate: "30/07/2024",
    status: true,
  },
  {
    accountNumber: "LD100640",
    outstandingBalance: "800.000.000",
    currency: "VND",
    maturityDate: "20/08/2024",
    status: true,
  },
];

const accountDetailHistory = [
  {
    transactionId: "FT345678XY21",
    transactionDate: "15/04/2023",
    transactionRemarks: "MBBP:5432 CHUYEN TIEN LIEN NGAN HANG",
    debitAmount: "250,000",
    creditAmount: "",
  },
  {
    transactionId: "FT987654XY32",
    transactionDate: "03/11/2023",
    transactionRemarks: "MBBP:7841 THANH TOAN THE TIN DUNG",
    debitAmount: "",
    creditAmount: "600,000,000",
  },
  {
    transactionId: "FT456123XY54",
    transactionDate: "27/07/2023",
    transactionRemarks: "MBBP:1298 RUT TIEN ATM",
    debitAmount: "500,000",
    creditAmount: "",
  },
  {
    transactionId: "FT763829XY89",
    transactionDate: "09/02/2023",
    transactionRemarks: "MBBP:8923 THANH TOAN HOA DON DIEN",
    debitAmount: "120,000",
    creditAmount: "",
  },
  {
    transactionId: "FT234567XY76",
    transactionDate: "22/06/2023",
    transactionRemarks: "MBBP:6721 NAP TIEN VI DIEN TU",
    debitAmount: "",
    creditAmount: "900,000,000",
  },
  {
    transactionId: "FT875412XY45",
    transactionDate: "18/09/2023",
    transactionRemarks: "MBBP:3417 CHUYEN KHOAN NOI BO",
    debitAmount: "750,000",
    creditAmount: "",
  },
  {
    transactionId: "FT987123XY33",
    transactionDate: "01/01/2023",
    transactionRemarks: "MBBP:2145 RUT TIEN ATM",
    debitAmount: "",
    creditAmount: "700,000,000",
  },
  {
    transactionId: "FT654321XY87",
    transactionDate: "05/05/2023",
    transactionRemarks: "MBBP:9213 THANH TOAN THE TIN DUNG",
    debitAmount: "800,000",
    creditAmount: "",
  },
  {
    transactionId: "FT876543XY22",
    transactionDate: "30/10/2023",
    transactionRemarks: "MBBP:4625 CHUYEN TIEN LIEN NGAN HANG",
    debitAmount: "",
    creditAmount: "480,000,000",
  },
  {
    transactionId: "FT214365XY99",
    transactionDate: "12/08/2023",
    transactionRemarks: "MBBP:7352 NAP TIEN VI DIEN TU",
    debitAmount: "",
    creditAmount: "500,000,000",
  },
];

const accountViewStatement = [
  {
    transactionDate: "02/04/2023",
    transactionRemarks: "MBBP:1234 VNP-TOPUP NẠP TIỀN ĐIỆN THOẠI",
    debitAmount: "2.500.000",
    creditAmount: "2.000.000",
    runningBalance: "498,500,000",
    transactionId: "FT98765AB1CD",
    beneficiary: "CT TNHH HOÀNG ANH",
  },
  {
    transactionDate: "03/05/2023",
    transactionRemarks: "VCB:4567 CHUYỂN KHOẢN NỘI BỘ",
    debitAmount: "3.750.000",
    creditAmount: "",
    runningBalance: "246,250,000",
    transactionId: "FT65432YZ8LM",
    payer: "CTCP BÌNH MINH",
  },
  {
    transactionDate: "05/06/2023",
    transactionRemarks: "ACB:7890 THANH TOÁN HÓA ĐƠN",
    debitAmount: "1.200.000",
    creditAmount: "",
    runningBalance: "98,800,000",
    transactionId: "FT32109QR7ST",
    payer: "CTCP SÁNG TẠO",
  },
  {
    transactionDate: "12/07/2023",
    transactionRemarks: "VIETINBANK:1111 THANH TOÁN DỊCH VỤ",
    debitAmount: "5.000.000",
    creditAmount: "8.000.000",
    runningBalance: "45,000,000",
    transactionId: "FT45678GH9JK",
    payer: "CÔNG TY TNHH HƯNG THỊNH",
  },
  {
    transactionDate: "20/08/2023",
    transactionRemarks: "AGRIBANK:2222 RÚT TIỀN ATM",
    debitAmount: "2.000.000",
    creditAmount: "",
    runningBalance: "28,000,000",
    transactionId: "FT89012WX3UV",
    payer: "CÁ NHÂN NGUYỄN VĂN A",
  },
  {
    transactionDate: "28/09/2023",
    transactionRemarks: "TECHCOMBANK:3333 CHUYỂN KHOẢN ONLINE",
    debitAmount: "6.500.000",
    creditAmount: "9.000.000",
    runningBalance: "13,500,000",
    transactionId: "FT54321OP5QR",
    payer: "CÔNG TY CP PHÁT TRIỂN ABC",
  },
  {
    transactionDate: "10/10/2023",
    transactionRemarks: "SACOMBANK:4444 THANH TOÁN TIỀN HÀNG",
    debitAmount: "8.000.000",
    creditAmount: "",
    runningBalance: "7,000,000",
    transactionId: "FT67890MN6XY",
    payer: "DOANH NGHIỆP TƯ NHÂN XYZ",
  },
];

const accountViewInstallment = [
  {
    dueDate: "01/03/2022",
    Liability: "360.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/04/2022",
    Liability: "340.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/05/2022",
    Liability: "320.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/06/2022",
    Liability: "300.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/07/2022",
    Liability: "280.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/08/2022",
    Liability: "260.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/09/2022",
    Liability: "240.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/10/2022",
    Liability: "220.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/11/2022",
    Liability: "200.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
  {
    dueDate: "01/12/2022",
    Liability: "180.000.000",
    installment: "21.000.000",
    principal: "20.000.000",
    interest: "1.000.000",
  },
];

const accountRenewalHistory = [
  {
    principalAmount: "101.000.000",
    interestRate: "10% /",
    interestAmount: "5.555",
    valueDate: "01/03/2022",
    maturityDate: "01/12/2022",
  },
  {
    principalAmount: "95.000.000",
    interestRate: "9.5% /",
    interestAmount: "4.500",
    valueDate: "01/01/2022",
    maturityDate: "01/10/2022",
  },
  {
    principalAmount: "120.000.000",
    interestRate: "11% /",
    interestAmount: "6.600",
    valueDate: "15/02/2022",
    maturityDate: "15/11/2022",
  },
  {
    principalAmount: "80.000.000",
    interestRate: "8% /",
    interestAmount: "3.200",
    valueDate: "10/03/2022",
    maturityDate: "10/09/2022",
  },
  {
    principalAmount: "110.000.000",
    interestRate: "10.5% /",
    interestAmount: "5.775",
    valueDate: "05/04/2022",
    maturityDate: "05/12/2022",
  },
  {
    principalAmount: "130.000.000",
    interestRate: "12% /",
    interestAmount: "7.800",
    valueDate: "01/05/2022",
    maturityDate: "01/01/2023",
  },
  {
    principalAmount: "90.000.000",
    interestRate: "9% /",
    interestAmount: "4.050",
    valueDate: "20/06/2022",
    maturityDate: "20/12/2022",
  },
  {
    principalAmount: "105.000.000",
    interestRate: "10.2% /",
    interestAmount: "5.355",
    valueDate: "01/07/2022",
    maturityDate: "01/02/2023",
  },
  {
    principalAmount: "115.000.000",
    interestRate: "10.8% /",
    interestAmount: "6.210",
    valueDate: "10/08/2022",
    maturityDate: "10/03/2023",
  },
  {
    principalAmount: "100.000.000",
    interestRate: "10% /",
    interestAmount: "5.000",
    valueDate: "01/09/2022",
    maturityDate: "01/06/2023",
  },
];

const debitCardData = [
  {
    cardNumber: "1111 11** **** 5307",
    name: "NGUYEN HOANG NAM TIEN",
    accountNumber: "060004738201",
    available: "12.345.000 VND",
    status: true,
  },
  {
    cardNumber: "5234 56** **** 7890",
    name: "LE THI B",
    accountNumber: "060004738202",
    available: "25.678.000 VND",
    status: false,
  },
  {
    cardNumber: "6345 67** **** 8901",
    name: "NGUYEN HOANG C",
    accountNumber: "060004738203",
    available: "36.789.000 VND",
    status: true,
  },
  {
    cardNumber: "7456 78** **** 9012",
    name: "PHAM VAN D",
    accountNumber: "060004738204",
    available: "45.123.000 VND",
    status: false,
  },
  {
    cardNumber: "8567 89** **** 0123",
    name: "DO THI E",
    accountNumber: "060004738205",
    available: "56.456.000 VND",
    status: true,
  },
  {
    cardNumber: "9678 90** **** 1234",
    name: "VU NGOC F",
    accountNumber: "060004738206",
    available: "67.789.000 VND",
    status: false,
  },
  {
    cardNumber: "1789 01** **** 2345",
    name: "HOANG MINH G",
    accountNumber: "060004738207",
    available: "78.912.000 VND",
    status: true,
  },
  {
    cardNumber: "2890 12** **** 3456",
    name: "BUI THANH H",
    accountNumber: "060004738208",
    available: "89.234.000 VND",
    status: false,
  },
  {
    cardNumber: "3901 23** **** 4567",
    name: "NGUYEN HAI I",
    accountNumber: "060004738209",
    available: "91.567.000 VND",
    status: true,
  },
  {
    cardNumber: "4902 34** **** 5678",
    name: "TRAN VAN J",
    accountNumber: "060004738210",
    available: "103.678.000 VND",
    status: false,
  },
  {
    cardNumber: "5903 45** **** 6789",
    name: "PHAM THANH K",
    accountNumber: "060004738211",
    available: "115.890.000 VND",
    status: true,
  },
  {
    cardNumber: "6904 56** **** 7890",
    name: "DOAN VAN L",
    accountNumber: "060004738212",
    available: "127.345.000 VND",
    status: false,
  },
  {
    cardNumber: "7905 67** **** 8901",
    name: "DINH NGOC M",
    accountNumber: "060004738213",
    available: "138.678.000 VND",
    status: true,
  },
  {
    cardNumber: "8906 78** **** 9012",
    name: "NGUYEN THI N",
    accountNumber: "060004738214",
    available: "149.890.000 VND",
    status: false,
  },
  {
    cardNumber: "9907 89** **** 0123",
    name: "LE HOANG O",
    accountNumber: "060004738215",
    available: "160.123.000 VND",
    status: true,
  },
  {
    cardNumber: "1908 90** **** 1234",
    name: "PHAM MINH P",
    accountNumber: "060004738216",
    available: "171.456.000 VND",
    status: false,
  },
  {
    cardNumber: "2909 01** **** 2345",
    name: "HO THI Q",
    accountNumber: "060004738217",
    available: "182.789.000 VND",
    status: true,
  },
  {
    cardNumber: "3910 12** **** 3456",
    name: "VU NGOC R",
    accountNumber: "060004738218",
    available: "194.567.000 VND",
    status: false,
  },
  {
    cardNumber: "4911 23** **** 4567",
    name: "BUI THAI S",
    accountNumber: "060004738219",
    available: "205.678.000 VND",
    status: true,
  },
  {
    cardNumber: "5912 34** **** 5678",
    name: "DINH VAN T",
    accountNumber: "060004738220",
    available: "216.789.000 VND",
    status: false,
  },
  {
    cardNumber: "6913 45** **** 6789",
    name: "TRAN NGOC U",
    accountNumber: "060004738221",
    available: "228.890.000 VND",
    status: true,
  },
  {
    cardNumber: "7914 56** **** 7890",
    name: "LE THANH V",
    accountNumber: "060004738222",
    available: "239.123.000 VND",
    status: false,
  },
];

const creditCardData = [
  {
    cardNumber: "4720 47** **** 8888",
    name: "NGUYEN VAN A",
    creditLimit: "50.000.000 VND",
    currentOutstanding: "0",
    lastBilledAmount: "0",
    status: true,
  },
  {
    cardNumber: "9832 12** **** 3471",
    name: "Trần Thị B",
    creditLimit: "60.000.000 VND",
    currentOutstanding: "2.000.000 VND",
    lastBilledAmount: "1.000.000 VND",
    status: false,
  },
  {
    cardNumber: "1123 78** **** 1265",
    name: "Lê Văn C",
    creditLimit: "75.000.000 VND",
    currentOutstanding: "5.000.000 VND",
    lastBilledAmount: "2.500.000 VND",
    status: true,
  },
  {
    cardNumber: "6674 45** **** 9823",
    name: "Phạm Thị D",
    creditLimit: "85.000.000 VND",
    currentOutstanding: "10.000.000 VND",
    lastBilledAmount: "4.000.000 VND",
    status: false,
  },
  {
    cardNumber: "2201 99** **** 3345",
    name: "Nguyễn Thị E",
    creditLimit: "95.000.000 VND",
    currentOutstanding: "7.500.000 VND",
    lastBilledAmount: "3.000.000 VND",
    status: true,
  },
  {
    cardNumber: "5598 66** **** 5720",
    name: "Trần Văn F",
    creditLimit: "110.000.000 VND",
    currentOutstanding: "20.000.000 VND",
    lastBilledAmount: "8.000.000 VND",
    status: true,
  },
  {
    cardNumber: "3347 22** **** 4981",
    name: "Lê Thị G",
    creditLimit: "115.000.000 VND",
    currentOutstanding: "15.000.000 VND",
    lastBilledAmount: "5.000.000 VND",
    status: false,
  },
  {
    cardNumber: "7789 88** **** 1236",
    name: "Phạm Văn H",
    creditLimit: "125.000.000 VND",
    currentOutstanding: "12.500.000 VND",
    lastBilledAmount: "6.000.000 VND",
    status: true,
  },
  {
    cardNumber: "9910 33** **** 2145",
    name: "Nguyễn Văn I",
    creditLimit: "130.000.000 VND",
    currentOutstanding: "30.000.000 VND",
    lastBilledAmount: "10.000.000 VND",
    status: false,
  },
  {
    cardNumber: "5566 77** **** 8412",
    name: "Trần Thị J",
    creditLimit: "145.000.000 VND",
    currentOutstanding: "40.000.000 VND",
    lastBilledAmount: "15.000.000 VND",
    status: true,
  },
];

export default {
  currentAccountData,
  depositAccountData,
  loanAccountData,
  accountDetailHistory,
  accountViewStatement,
  debitCardData,
  creditCardData,
  accountViewInstallment,
  accountRenewalHistory,
};
